module.exports = __webpack_public_path__ + "static/img/digital-health-solutions-radar.ab2e240.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital-health-solutions-radar.jpg
// module id = bv8+
// module chunks = 2